import { GetServerSideProps } from "next";
import { Col, Container, Row } from "react-bootstrap";
import { RichText } from "../components/RichText";
import api from "../lib/utils/api";
import styles from "../styles/Subpage.module.css";
import cmsEndpoints from "../lib/utils/cmsEndpoints";
import { mapSubpageData } from "../lib/utils/mappers";
import { Locale } from "../lib/types";
import { PageHead } from "../components/PageHead";

export const getServerSideProps: GetServerSideProps = async (context) => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )
  const locale = context.locale as Locale
  const slug = context.params?.subpage

  const pageData = await api.get(cmsEndpoints.subPage(slug as string))
  if (!pageData?.data?.data?.length) return { notFound: true }

  const page = mapSubpageData(pageData?.data?.data?.[0]?.attributes, locale)

  return {
    props: {
      page
    }
  }
}


const Subpage = (props: { page: { shareTitle: string, shareDescription: string, content: string } } ) => {
  return (
    <>
      <PageHead title={props.page?.shareTitle} description={props.page?.shareDescription} />
      <div className={styles.container}>
        <Container fluid="lg" className="py-5 px-lg-5">
          <Row>
            <Col>
              <RichText content={props.page.content} />
            </Col>
          </Row>
        </Container >
      </div>
    </>
  )
}

export default Subpage
